export const white = '#FFFFFF';
export const black = '#000000';
// Bright magenta color used as a fallback for palette properties that exist
// only for backwards compatibility and should never be visible in the UI.
export const INVALID_FALLBACK_COLOR = '#FF00FF';
